import useFilterContact from '../../../../../hooks/useFilterContact'
import FilterBox from './FilterBox'
import FilterContactHeader from './FilterContactHeader'

const FilterContact = () => {
  const { 
    currContactAddresses, 
    searchWord,
    setSearchWord,
    filter,
    setFilter,
    isFavorites,
    setIsFavorites,
    selectedSort,
    setSelectedSort,
    sortOptions,
    isAsc,
    setIsAsc,
    selectedGroup,
    setSelectedGroup,
  } = useFilterContact()
  
  return (
    <>
      <FilterContactHeader currContactAddresses={currContactAddresses} />
      <FilterBox searchWord={searchWord} setSearchWord={setSearchWord} filter={filter} setFilter={setFilter} isFavorites={isFavorites} setIsFavorites={setIsFavorites} selectedSort={selectedSort} setSelectedSort={setSelectedSort} sortOptions={sortOptions} isAsc={isAsc} setIsAsc={setIsAsc} selectedGroup={selectedGroup} setSelectedGroup={setSelectedGroup} />
    </>
  )
}

export default FilterContact
